import { Instagram, Mail, MapPin, Phone } from 'lucide-react';
import { FaWhatsapp } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';

export const socialLinks = [
  {
    name: 'Instagram',
    href: 'https://www.instagram.com/DigitalWaveAfrik',
    icon: Instagram,
  },
  {
    name: 'X',
    href: 'https://x.com/DigitalWavAfrik',
    icon: FaXTwitter,
  },
];

export const directContactInfo = [
  {
    name: 'Location',
    value: 'Kpone-Katamanso Municipality, Ghana',
    icon: MapPin,
  },
  {
    name: 'Email',
    value: 'info@dwaveafrik.org',
    href: 'mailto:info@dwaveafrik.org',
    icon: Mail,
  },
  {
    name: 'International Phone',
    value: '+1 (347) 961-3484',
    href: 'tel:+13479613484',
    icon: Phone,
  },
  {
    name: 'WhatsApp',
    value: '+1 (347) 961-3484',
    href: 'https://wa.me/+13479613484',
    icon: FaWhatsapp,
  },
];
